import { BAVEL_PATH } from '@config/app-config';
import { Injectable, inject } from '@angular/core';
import { Observable, of } from 'rxjs';
import { Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { IUsersService } from '@shared/interfaces/users-service.interface';

@Injectable({ providedIn: 'root' })
export class HasRoleGuard {
  private router: Router = inject(Router);
  private usersService: IUsersService = inject(IUsersService);

  /* eslint-disable @typescript-eslint/no-unused-vars */
  public canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    const role: string = route.data.role;

    if (this.checkHasRole(role)) {
      return of(true);
    }

    this.router.navigate([BAVEL_PATH.APP]);
    return of(false);
  }

  private checkHasRole(role: string): boolean {
    return this.usersService.userHasRole(role);
  }
}
